import { Spin } from 'antd'
import { PageWrapper, Logo, ProfilesWrapper, ProfileItem, LoadingText, Wrapper } from './index.styled'
import { useStudioSetup } from './useStudioSetup'
import LogoBadgeOutlined from '../../../images/LogoBadgeOutlined.png'
import LogoutIcon from '../../../images/logout.svg'
import { getAllStudioAsync } from '../../../redux/flows/auth/studio'
import { persistor } from '../../../redux/store'
import { APIStatus } from '../../../redux/types'

export default function StudioSetupScreen() {
  const { allStudios, allStudiosStatus, allStudiosError, selectStudio, navigate, dispatch } = useStudioSetup()

  return (
    <PageWrapper>
      <Logo
        src={LogoBadgeOutlined}
        onClick={() => {
          dispatch(getAllStudioAsync())
        }}
        alt="Kiro logo"
      />

      <div
        onClick={() => {
          persistor.purge()
          localStorage.clear()
          window.location.reload()
          setTimeout(() => {
            navigate('/doctor-login')
          }, 1000)
        }}
        style={{
          background: 'transparent',
          position: 'fixed',
          top: 24,
          right: 32,
          color: '#007F7C',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <img src={LogoutIcon} style={{ marginRight: '8px' }} />
      </div>

      {/* Studio list */}
      {allStudios && allStudios.length > 0 && allStudiosStatus !== APIStatus.pending && (
        <ProfilesWrapper>
          {allStudios.map((studio: any) => (
            <ProfileItem key={studio.id} onClick={() => selectStudio(studio)}>
              {studio.name}
            </ProfileItem>
          ))}
        </ProfilesWrapper>
      )}

      {/* Loading state */}
      {allStudiosStatus === APIStatus.pending && (
        <Wrapper>
          <Spin />
        </Wrapper>
      )}

      {/* Error fetching studio list */}
      {allStudiosStatus === APIStatus.rejected && allStudiosError && (
        <LoadingText style={{ color: '#e33939' }}>{allStudiosError}</LoadingText>
      )}
    </PageWrapper>
  )
}
